// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2w-1";
export var movingGradient = "_2w-4";
export var movingGradientBlock = "_2w-2";
export var skeleton = "_2w-0";
export var skeletonText = "_2w-3";